import { createTheme } from '@mui/material/styles'

const border = '#E3E6EC'

export const theme = createTheme({
  palette: {
    primary: { main: '#1E4FC2', dark: '#163C94', light: '#E8EEFC' },
    // Things for the organizer to act on
    warning: { main: '#E8772E', dark: '#B8520F', light: '#FCEBDD' },
    background: { default: '#F4F5F8', paper: '#FFFFFF' },
    text: { primary: '#15171C', secondary: '#5B6170' },
    divider: border,
  },
  shape: { borderRadius: 10 },
  typography: {
    fontFamily: '"Plus Jakarta Sans Variable", system-ui, sans-serif',
    h4: { fontWeight: 800, letterSpacing: '-0.02em' },
    h5: { fontWeight: 700 },
    h6: { fontWeight: 700, fontSize: '1.0625rem' },
    subtitle1: { fontWeight: 600 },
    button: { textTransform: 'none', fontWeight: 600 },
  },
  components: {
    MuiButton: { defaultProps: { disableElevation: true } },
    MuiPaper: {
      styleOverrides: {
        outlined: { borderColor: border, borderRadius: 14 },
      },
    },
    MuiDialog: {
      styleOverrides: {
        // A form wrapping DialogContent and DialogActions must pass the flex layout on, or the actions scroll away
        paper: { '& > form': { display: 'flex', flexDirection: 'column', minHeight: 0 } },
      },
    },
    MuiChip: { styleOverrides: { root: { fontWeight: 600 } } },
    MuiLink: { defaultProps: { underline: 'hover' } },
  },
})
